import { Component, Input, EventEmitter, Output, OnInit, OnChanges, OnDestroy, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EMPTY, forkJoin, Subscription, switchMap } from 'rxjs';
import { ServicecallService } from 'src/app/services';


@Component({
    selector: 'app-floorplan-ota-update',
    templateUrl: './floorplan-ota-update.component.html',
    styleUrls: ['./floorplan-ota-update.component.scss']
})
export class FloorplanOtaUpdateComponent implements OnInit, OnDestroy {

    selectedModule = new FormControl('', [Validators.required]);
    desiredValues = new FormControl('', [Validators.required]);
    availableModules: { name: string, value: string }[] = [];

    //Subscription
    private _moduleSubscription: Subscription;
    private _twinUpdateSubscription: Subscription;
    private _twinValueSubscription: Subscription;
    private _syncConfigMessageSubscription: Subscription;

    constructor(public dialogRef: MatDialogRef<FloorplanOtaUpdateComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public _apiService: ServicecallService) { }

    ngOnInit(): void {
        // this.availableModules = this._apiService.getConfiguration(
        //     'tenantGenericConfig'
        // )?.moduleList || [];
        if (this.data?.plot?.category === 'Gateway') {
            this.fetchModules();
        } else {
            this.fetchAttributes();
        }
    }

    ngOnDestroy(): void {
        this._moduleSubscription?.unsubscribe();
        this._twinUpdateSubscription?.unsubscribe();
        this._twinValueSubscription?.unsubscribe();
        this._syncConfigMessageSubscription?.unsubscribe();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    onUpdate(): void {
        try {
            let desiredProperties: any;
            const formValue = this.desiredValues.value;

            if (typeof formValue === 'string') {
                desiredProperties = JSON.parse(formValue);
            } else {
                desiredProperties = formValue;
            }

            const reqPayload = [{
                deviceId: this.data?.plot?.deviceId,
                moduleId: this.selectedModule.value,
                desiredProperties: desiredProperties
            }];

            this._twinUpdateSubscription = this._apiService.updateTwinModule(reqPayload).subscribe({
                next: () => {
                    this._apiService.toasterService({
                        type: 'success',
                        msg: 'Updated successfully',
                    });
                    this.dialogRef.close(true);
                },
                error: () => {
                    this._apiService.toasterService({
                        type: 'error',
                        msg: 'Unable to update',
                    });
                }
            });

        } catch (error) {
            this._apiService.toasterService({
                type: 'error',
                msg: 'Invalid JSON format. Please correct the configuration.',
            });
        }
    }

    fetchModules() {
        this._moduleSubscription = this._apiService.twinModulesList(this.data?.plot?.deviceId).subscribe({
            next: (response: any) => {
                this.availableModules = response?.modules?.map((module: any) => ({
                    name: module,
                    value: module
                })) || [];
            },
            error: () => {
                this._apiService.toasterService({
                    type: 'error',
                    msg: 'Unable to fetch modules',
                });
            }
        });

    }

    onModuleChange(value: any) {
        const payload = {
            deviceId: this.data?.plot?.deviceId,
            moduleId: value
        }
        this._twinValueSubscription = this._apiService.fetchTwinValue(payload).subscribe({
            next: (response: any) => {
                this.desiredValues.setValue(JSON.stringify(response?.properties?.desired || {}));
            },
            error: () => {
                this._apiService.toasterService({
                    type: 'error',
                    msg: 'Unable to fetch module details',
                });
            }
        });
    }

    fetchAttributes() {
        this._twinValueSubscription = this._apiService.fetchTwinAttributes(this.data?.plot?.entityId).subscribe({
            next: (response: any) => {
                this.desiredValues.setValue(JSON.stringify(response?.attributes || []));
            },
            error: () => {
                this._apiService.toasterService({
                    type: 'error',
                    msg: 'Unable to fetch details',
                });
            }
        });
    }

    updateAttributes() {
        try {
            let desiredProperties: any;
            const formValue = this.desiredValues.value;

            if (typeof formValue === 'string') {
                desiredProperties = JSON.parse(formValue);
            } else {
                desiredProperties = formValue;
            }

            const reqPayload = {
                attributes: desiredProperties
            };

            this._twinUpdateSubscription = this._apiService
                .updateTwinAttributes(reqPayload, this.data?.plot?.entityId)
                .pipe(
                    switchMap(() => {
                        const syncList =
                            this._apiService.getConfiguration('syncInfo')?.syncInfo || [];

                        if (!syncList.length) {
                            this._apiService.toasterService({
                                type: 'warning',
                                msg: 'No configuration for sync available'
                            });
                            return EMPTY; // stop further execution
                        }

                        // Run all sync APIs in parallel
                        return forkJoin(
                            syncList.map((item: any) =>
                                this._apiService.syncConfigMessage(item)
                            )
                        );
                    })
                )
                .subscribe({
                    next: (responses: any[]) => {
                        // Handle sync responses
                        if (responses) {
                            responses.forEach(res => {
                                this._apiService.toasterService({
                                    type: res.status ? 'success' : 'error',
                                    msg: res?.response?.message
                                });
                            });
                        }

                        // Final success
                        this._apiService.toasterService({
                            type: 'success',
                            msg: 'Updated successfully'
                        });

                        this.dialogRef.close(true);
                    },
                    error: () => {
                        this._apiService.toasterService({
                            type: 'error',
                            msg: 'Unable to update'
                        });
                    }
                });

        } catch (error) {
            this._apiService.toasterService({
                type: 'error',
                msg: 'Invalid JSON format. Please correct the configuration.'
            });
        }
    }

}